import React from "react";
import { StyledHeader } from "../styledComponent/styledHeader";
import { Button, Dropdown } from "antd";
import {
  AiOutlineLogout,
  AiOutlineMenuFold,
  AiOutlineMenuUnfold,
} from "react-icons/ai";
import { UserAvatar } from "../avatar/avatar";
import { useNavigate } from "react-router-dom";
import { logout } from "../../server/authServer";
import { useAppContext } from "../../contexts/appContext";

function NavigationBar({ collapsed, setCollapsed }) {
  const { setUser } = useAppContext();
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    setUser();
    navigate("/login");
  };
  const items = [
    {
      key: "1",
      label: (
        <div className="menu-item-div p-2" onClick={handleLogout}>
          <AiOutlineLogout /> <span>Logout</span>
        </div>
      ),
    },
  ];
  return (
    <StyledHeader>
      <Button
        type="text"
        icon={collapsed ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
        onClick={() => setCollapsed(!collapsed)}
        style={{
          fontSize: "20px",
          padding: 24,
        }}
      />
      <Dropdown
        menu={{ items }}
        trigger={["click"]}
        placement="bottom"
        className="avatar-dropdown"
      >
        <div className="clickable">
          <UserAvatar size={40} />
        </div>
      </Dropdown>
    </StyledHeader>
  );
}

export default NavigationBar;
